export default "__VITE_ASSET__CZHP_qy2__"